import React from 'react'
import styled from 'styled-components'
import {compose, withState} from 'recompose'
import CloseButtonImage from '../static/1_objects.svg'
import {browserHistory} from 'react-router'
import BurgerImage from '../static/burger.svg'
import Select from '../basic/select'
import phoneIcon from '../static/icons/phone.svg'
import GA from 'react-ga'
import ym from 'react-yandex-metrika';
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const Icon = styled.div`
  position: absolute;
  background: url(${props => props.open ? CloseButtonImage : BurgerImage}) no-repeat center;
  top: 39px;
  display: inline-block;
  width: 36px;
  ${props => props.open ? 'right: 10px; width: 10px; height: 10px; top: 10px;' : 'left: 16px;'}
  height: 22px;
  background-size: cover;
  cursor: pointer;
  outline: none;
  z-index: ${props => props.open ? 15 : 2};
`

const BurgerNav = styled.div`
  display: ${props => props.open ? 'block' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgb(51,78,251);
  opacity: .9;
  padding: 46px 69px 30px 63px;
  padding-left: 25px;
  padding-top: 25px;
  padding-right: 120px;
  z-index: 11;
  
  & > div {
    padding-top: 10px;
    color: white;
    text-decoration: none;
    cursor: pointer;
    padding-bottom: 15px;
  }
`

const MobileTel = styled.a`
  position: absolute; 
  top: 0;
  left: 16px;
  text-decoration: none;
  color: #5C707B;
  font-size: 13px; 
  display: flex;
  align-items: center;
`;

function Card({href, label, ...other}) {
  return (
    <option value={href} {...other}>
      {label}
    </option>
  )
}


const Burger = ({ open, setOpen }) => (
  <div className="burger">
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return currentLanguage !== 'ua' && currentLanguage !== 'en' ? (
          <MobileTel
            href="tel:+7 (499) 426-36-27"
            onClick={() => {
              GA.event({
                category: 'number',
                action: 'click',
                label: 'number_click'
              });
              ym('reachGoal', 'number_click');
            }}
          >
            <img src={phoneIcon} style={{verticalAlign: 'middle', height: 18, marginRight: 3}}/>
            7 (499) 426-36-27
          </MobileTel>
        ) : null;
      }}
    </CurrentLanguageContext.Consumer>
    <Icon
      onClick={() => {
        setOpen(!open)
      }}
      open={open}
    />
    <BurgerNav
      open={open}
    >
      <div
        onClick={() => {
          document.querySelector(`#question`).scrollIntoView();
          window.scrollBy(0, -140)
          setOpen(false)
        }}
      >
        <TranslateText id="nav_question" place="right" />
      </div>
      <div style={{ paddingBottom: 0 }}>
        <TranslateText
          id="nav_about_fw"
          place="right"
          render={text => {
            return (
              <Select
                label={text}
                theme='mobile-nav'
                onChange={(e) => {
                  browserHistory.push(e.target.value)
                  setOpen(false)
                }}
                style={{background: 'transparent', paddingBottom: 30}}
              >
                <Card href={`/about`} label={''} hidden/>
                <TranslateText
                  id="nav_about_fw__company"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/about`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_about_fw__news"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/news`} label={text} /> 
                    );
                  }}
                />
              </Select>
            );
          }}
        />
      </div>

      <div style={{'padding-bottom': 0}}>
        <TranslateText
          id="nav_products"
          place="right"
          render={text => {
            return (
              <Select
                label={text}
                theme='mobile-nav'
                onChange={(e) => {
                  browserHistory.push(e.target.value)
                  setOpen(false)
                }}
              >
                <Card href={`/production`} label={''} hidden/>
                <TranslateText
                  id="nav_products"
                  hideTooltip
                  render={text => {
                    return (
                      // Раньше называлось "Вся", теперь это не возможно в связи с функционалом перевода, текст берется из одного источника
                      <Card href={`/production`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__clutch"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/sceplenie`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__brake_pads"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/kolodki`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__absorbers"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/amortisatory`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__wires"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/provoda2`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__crossews"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/krestovina`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__shrus"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/shrus`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__gas_stops"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/gazoviy_upor`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__wheel_bearings"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/podshipnik`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__wiper_blades"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/schetki`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__drive_parts_grm"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/yA7_BD`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__drive_belts"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/utc_BV`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__cooling_system_pumps"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/pompa`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__termostats"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/termostat`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__filters"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/vozdushniy_filter`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__spark_plug"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/svecha`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__suspension_parts"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/nakonechnik`} label={text} /> 
                    );
                  }}
                />
                <TranslateText
                  id="nav_products__katushki"
                  hideTooltip
                  render={text => {
                    return (
                      <Card href={`/katushki`} label={text} />
                    );
                  }}
                />
              </Select>
            );
          }}
        />
      </div>
      <div
        onClick={() => {
          browserHistory.push('/partners')
          setOpen(false)
        }}
      >
        <TranslateText id="nav_partners" place="right" />
      </div>
      <div
        onClick={() => {
          browserHistory.push('/retail-stores')
          setOpen(false)
        }}
      >
        <TranslateText id="nav_where_buy" place="right" />
      </div>
      <Icon
        onClick={() => {
          setOpen(!open)
        }}
        open={open}
      />
    </BurgerNav>
  </div>
)

export default compose(
  withState('open', 'setOpen', false),
)(Burger)



// WEBPACK FOOTER //
// ./src/finwhale/burger.js